import { isNull } from 'lodash-es';
import { CenteredLoading } from '../../lib/centered-loading';
import { ModalActionBar, ModalContent } from '../../lib/ds/modal/modal';
import { ModalHeader } from '../../lib/ds/modal/modal-header';
import { Header1, Paragraph } from '../../lib/ds/typography/typography';
import { AufgabeAktionen } from './aufgabe-aktionen';
import { AufgabenDetails } from './aufgaben-details';
import type { AufgabeAbschliessenModel } from './model';
import { UmfrageAufgabeAktionen } from './umfrage-aufgabe-aktionen';

export type AufgabeAbschliessenModalProps = {
  aufgabe: AufgabeAbschliessenModel | null;
  isLoading: boolean;
  onClose: () => void;
  onAfterAction?: () => void;
  onAufgabeAbschliessen: (id: string, ergebnis: string, ergebnisOption?: string, kommentar?: string) => Promise<unknown>;
  onAufgabeZwischenergebnisErfassen?: (id: string, zwischenErgebnisOption: string, kommentar: string) => Promise<unknown>;
  canAufgabeAbschliessen: ((aufgabe: { status: string | null; ergebnis: string | null }) => boolean);
};

export const AufgabeAbschliessenModal = (props: AufgabeAbschliessenModalProps) => {
  const aufgabe = props.aufgabe;

  return (
    <>
      <ModalHeader title={aufgabe?.typ || 'Aufgabe wird geladen'} onClose={props.onClose}/>
      <ModalContent className="flex flex-col gap-100">
        {props.isLoading ? <CenteredLoading /> : <>
          <Header1>{aufgabe?.titel}</Header1>
          <Paragraph>{aufgabe?.beschreibung}</Paragraph>
          <AufgabenDetails aufgabe={aufgabe} />
        </> }
      </ModalContent>
      {isNull(aufgabe) ? null :
        <ModalActionBar cssClassNames="flex flex-col gap-100">
          {aufgabe.typ === 'Umfrage' ? (
            <UmfrageAufgabeAktionen
              aufgabe={aufgabe}
              onAufgabeAbschliessen={props.onAufgabeAbschliessen}
              onAufgabeZwischenergebnisErfassen={props.onAufgabeZwischenergebnisErfassen}
              canAufgabeAbschliessen={props.canAufgabeAbschliessen}/>
          ) : (
            <AufgabeAktionen
              aufgabe={aufgabe}
              onAfterAction={props.onAfterAction}
              onAufgabeAbschliessen={props.onAufgabeAbschliessen}
              onAufgabeZwischenergebnisErfassen={props.onAufgabeZwischenergebnisErfassen}
              canAufgabeAbschliessen={props.canAufgabeAbschliessen}/>
          )}
        </ModalActionBar>
      }
    </>
  );
};
